export const home = '/';
export const dashboard = '/dash';
export const videoOverlay = '/video_overlay.html';